// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetSubAgentsDesktopRequest,
  TGetSubAgentsDesktopModel,
  IMappers,
  TGetSubAgentsDesktopResponse,
  IGetSubAgentsDesktopResponse,
  IGetSubAgentsDesktopResponseError,
} from './types';

export const defaultConfig: TGetSubAgentsDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/get-sub-agents-desktop/',
} as TGetSubAgentsDesktopModel;

export function createGetSubAgentsDesktopModel(parameters: IGetSubAgentsDesktopRequest): TGetSubAgentsDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetSubAgentsDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetSubAgentsDesktopRequest;
}

export async function fetchGetSubAgentsDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSubAgentsDesktopOptions<TResponse200, TResponse400>): Promise<
  TGetSubAgentsDesktopResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetSubAgentsDesktopModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSubAgentsDesktopResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetSubAgentsDesktopResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetSubAgentsDesktopResponse;
}
